import React from "react";

const LastUpdated = ({ data, user, showLastUpdated }) => {
  const moment = require("moment-timezone");
  return (
    <>
      {showLastUpdated && (
        <div style={{ marginTop: "1rem" }}>
          Last Updated:
          {moment(data)
            .tz(user.preferences.timeZone)
            .format("L, LTS z")}
        </div>
      )}
    </>
  );
};

export default LastUpdated;
